module.exports = __webpack_public_path__ + "media/careers/careers_coworkers3-b767dcfb.jpeg";